function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 4.440892098500626e-16, 0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M15.99,17.056c4.7,0,8.532-3.828,8.532-8.53S20.69,0,15.99,0c-4.702,0-8.528,3.823-8.528,8.525 S11.288,17.056,15.99,17.056z M15.99,2.235c3.473,0,6.294,2.824,6.294,6.29c0,3.473-2.821,6.286-6.294,6.286 c-3.466,0-6.291-2.813-6.291-6.286C9.699,5.06,12.524,2.235,15.99,2.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M 31.866 30.332 C 30.247 24.617 25.667 20.289 20.088 18.852 C 20.027 18.831 19.968 18.815 19.903 18.809 C 18.637 18.493 17.333 18.331 15.99 18.331 C 8.677 18.331 2.151 23.228 0.136 30.263 C -0.035 30.856 0.307 31.469 0.896 31.643 C 1.496 31.813 2.11 31.469 2.287 30.874 C 3.56 26.438 6.907 22.987 11.092 21.441 L 13.324 20.825 C 14.191 20.656 15.082 20.567 15.991 20.567 C 16.879 20.567 17.76 20.644 18.614 20.809 L 20.845 21.426 C 25.068 22.963 28.449 26.447 29.718 30.931 C 29.855 31.427 30.302 31.744 30.787 31.744 C 30.886 31.744 30.997 31.729 31.096 31.709 C 31.69 31.541 32.035 30.916 31.866 30.332 Z"
}));

var SvgNoBinIcon = function SvgNoBinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoBinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noBinIcon.579bf5fd.svg";
export { ForwardRef as ReactComponent };